import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getTable } from '../../api/api';
import { formatDate } from '../../utils/helpers';

const PublicationCard = ({ pub }) => (
  <Link to={`/publication/${pub.slug}`} className="card">
    <div className="card-media">
      <img src={pub.image_url} alt={pub.title} loading="lazy" />
    </div>
    <div className="card-body">
      <div className="card-tags">
        <span className="tag">{pub.doc_type}</span>
        <span className={`tag access-${pub.access_level}`}>{pub.access_level}</span>
      </div>
      <h3>{pub.title}</h3>
      <p className="excerpt">{(pub.summary || '').slice(0, 110)}...</p>
      <div className="card-meta">
        <span>{pub.author || ''}</span>
        <span>{formatDate(pub.publish_date)}</span>
      </div>
    </div>
  </Link>
);

const FeaturedPublications = () => {
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getTable('tables/publications', { limit: 100 });
        let list = res.data || [];
        const featured = list.filter((p) => p.featured).slice(0, 3);
        setPublications(featured.length ? featured : list.slice(0, 3));
      } catch (e) {
        console.error('Erreur chargement publications:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <section className="section">
        <div className="container">
          <div className="section-head">
            <div>
              <span className="section-kicker">Bibliothèque</span>
              <h2 className="section-title">Publications à la une</h2>
            </div>
          </div>
          <div className="grid grid-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="card" style={{ opacity: 0.6 }}>
                <div className="card-media" style={{ background: '#e1e5eb' }} />
                <div className="card-body">
                  <h3>Chargement...</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section">
      <div className="container">
        <div className="section-head">
          <div>
            <span className="section-kicker">Bibliothèque</span>
            <h2 className="section-title">Publications à la une</h2>
          </div>
          <Link to="/publications" className="btn btn-ghost">
            Toute la bibliothèque <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </div>

        <div className="grid grid-3">
          {publications.map((pub) => (
            <PublicationCard key={pub.id} pub={pub} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedPublications;